import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home/Home";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import Services from "./Pages/Services/Services";
import ScrollToTop from "./Utils/ScrollToTop";
import Contact from "./Pages/Contact/Contact";
import About from "./Pages/About/About";
import Blogs from "./Pages/Blogs/Blogs";
import BlogDetails from "./Pages/Blogs/BlogDetails";
import FoundersDesk from "./Pages/FoundersDesk/FoundersDesk";
import NriCorner from "./Pages/NriCorner/NriCorner";
import PageNotFound from "./Pages/404Page/PageNotFound";
import Gallery from "./Pages/Gallery/Gallery";
import Newsletter from "./Pages/Newsletter/Newsletter";
import Careers from "./Pages/Careers/Careers";
import PrivacyPolicy from "./Pages/PrivacyCondition/PrivacyPolicy";
import Disclaimer from "./Pages/PrivacyCondition/Disclaimer";
import { ReactNotifications } from "react-notifications-component";
import ServiceDetails from "./Pages/Services/ServiceDetails";
import Projects from "./Pages/Projects/Projects";
import ProjectDetails from "./Pages/Projects/ProjectDetails";
import LegalDocumentationSupport from "./Pages/PrivacyCondition/LegalDocumentationSupport";

function App() {
  return (
    <>
      <Router>
        <ReactNotifications />
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/founders-desk" element={<FoundersDesk />} />
          <Route path="/nri-corner" element={<NriCorner />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:blogslug" element={<BlogDetails />} />
          <Route path="/service/:serviceslug" element={<ServiceDetails />} />

          <Route path="/:projectcatslug" element={<Projects />} />

          <Route path="/media-coverage" element={<Gallery />} />

          <Route
            path="/:projectcatslug/:projectslug"
            element={<ProjectDetails />}
          />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route
            path="/legal-documentation-support"
            element={<LegalDocumentationSupport />}
          />
          <Route path="/page-not-found" element={<PageNotFound />} />
          <Route path="*" element={<Navigate to="/page-not-found" replace />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
